import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../GlobalContext";
import Lapbukubesar from "./pdf/Lapbukubesar";

function LapBukuBesar() {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);

  const [selectedBulan, setSelectedBulan] = useState(0);
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [kdperk, setkdperk] = useState('');
  const [daftarPerkiraan, setDaftarPerkiraan] = useState([]);
  const [loading, setLoading] = useState(false);

  // Ambil daftar kode perkiraan untuk dropdown
  useEffect(() => { 
    const getPerkiraan = async () => {
      try {
        const response = await api.get("/api/akuntansi");
        if (Array.isArray(response.data)) {
          setDaftarPerkiraan(response.data);
        } else {
          alert("Data perkiraan tidak tersedia.");
        }
      } catch (error) {
        console.error('Error fetching data perkiraan:', error);
        alert("Gagal mengambil data perkiraan.");
      }
    };  
    getPerkiraan();
  }, [api]);

  // Proses Data Laporan
  const handleSubmit = async (e) => {
    e.preventDefault();

    const bulanNumber = (selectedBulan + 1).toString().padStart(2, '0');
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    if (!kdperk) {
      alert('Silakan pilih Perkiraan terlebih dahulu.');
      return;
    }

    setLoading(true);
    try {
      const response = await api.get(`/api/akuntansi/bukubesar/${periode}/${kdperk}`);
      console.log(response.status);
      if (response.status === 404) {
        alert(`Data tidak ditemukan untuk periode ${periode}.`);
        setLoading(false);
        return;
      }

      if (response.status !== 200) {
        alert(`Server Error`);
        setLoading(false);
        return;
      }

      const result = response.data;

      // Ambil saldo awal
      const saldoResponse = await api.get(`/api/akuntansi/saldoperk/${periode}/${kdperk}`)      

      const posisi = saldoResponse?.data?.posisi ?? '';
      const awaldb = saldoResponse?.data?.awaldb ?? 0;
      const awalkd = saldoResponse?.data?.awalkd ?? 0;

      const saldoAwal = posisi === 'D' ? awaldb : awalkd;

      if (!Array.isArray(result) || result.length === 0) {
        alert(`Data tidak ditemukan untuk periode ${periode}.`);
        //setData([]);
      } else {
        //setData(result);
        const akunTerpilih = daftarPerkiraan.find(item => item.kdperk === kdperk);
        const namaAkun = akunTerpilih ? akunTerpilih.keterangan : "Nama Akun Tidak Diketahui";

        // Cetak PDF
        Lapbukubesar(periode, result, namaBulan, tahun, namaAkun, posisi, saldoAwal);
      }
    } catch (error) {
      console.error('Gagal mengambil data:', error);
      alert(`Terjadi kesalahan saat mengambil data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Handler Export Excel
  const handleExportExcel = async () => {
    const bulanNumber = (selectedBulan + 1).toString().padStart(2, '0');
    const periode = `${selectedYear}${bulanNumber}`;
    if (!kdperk) {
      alert('Silakan pilih Perkiraan terlebih dahulu.');
      return;
    }
    const url = `${api.defaults.baseURL.replace('/api','')}/api/exsportexcell/bukubesar/excel/${periode}/${kdperk}`;
    const filename = `BukuBesar_${periode}_${kdperk}.xlsx`;
    try {
      const response = await fetch(url, {
        credentials: "include",
        headers: { 
          "Accept": "application/json",            
          "Content-Type": "application/json" 
        }
      });
      if (!response.ok) {
        alert(`Gagal export Excel. Status: ${response.status}`);
        return;
      }
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert('Gagal export Excel: ' + err.message);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: '400px' }}>
            <div className="card-header">
              <h5 className="card-title">Laporan Buku Besar</h5>
            </div>
            <div className="card-body">
              <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={(e) => setSelectedBulan(parseInt(e.target.value))}
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>{item}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="kdperk" className="col-sm-3 col-form-label">Perkiraan</label>
                  <div className="col-sm-9">
                    <select
                      className="form-control"
                      value={kdperk}
                      onChange={(e) => setkdperk(e.target.value)}
                      required
                    >
                      <option value="">--pilih--</option>
                      {daftarPerkiraan.map((option) => (
                        <option key={option.kdperk} value={option.kdperk}>
                          {option.kdperk + ' - ' + option.keterangan}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    disabled={loading}
                  >
                    {loading ? 'Memproses...' : 'Cetak'}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-success ms-2"
                    onClick={handleExportExcel}
                    disabled={loading}
                  >
                    Export Excel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LapBukuBesar;
